import { Modal } from "@trackman/web-shared-components";
import { AppCopyText } from "components/ui";
import { useStores } from "index";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

type IFormDiagnosticsPackageModalProps = {
    diagnositcsPackageUrl: string;
};

const FormDiagnosticsPackageResponseModal = observer(({ diagnositcsPackageUrl }: IFormDiagnosticsPackageModalProps) => {
    const { t } = useTranslation();

    const { diagnosticsPackagesStore } = useStores();

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(diagnositcsPackageUrl);
        } finally {
            diagnosticsPackagesStore.resetCreationResponse()
        }
    };

    return (
        <Modal
            title={t('UserDiagnostics.CreateTicket.Title')}
            open={diagnosticsPackagesStore.hasFormResponse}
            onClose={() => { diagnosticsPackagesStore.resetCreationResponse() }}
            confirmBtn={{ label: t('UserDiagnostics.Action.CopyUrl'), onClick: () => handleCopy() }}
            cancelBtn={{ label: t('close'), onClick: () => diagnosticsPackagesStore.resetCreationResponse() }}
            style={{ zIndex: 2000 }}
        >
            <div className='d-flex justify-content-between align-items-center w-100'>
                <p data-test={`systemID-cell-text`} className='mb-0 overflow-ellipsis' title={diagnositcsPackageUrl}>
                    {diagnositcsPackageUrl}
                </p>
                <AppCopyText className='ml-1 ' text={diagnositcsPackageUrl} />
            </div>
        </Modal>
    );
});

export default FormDiagnosticsPackageResponseModal;
